module.exports = __webpack_public_path__ + "img/payment.9b3f424a.svg";